import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertOctagon } from 'lucide-react';
export function CostSection() {
  const costs = [{
    situation: '3 hs de planificación × 40 semanas',
    cost: '120 horas por año'
  }, {
    situation: 'Sin banco de frases clínicas',
    cost: '1 hora extra de registro por día'
  }, {
    situation: 'Sin sistema de primera consulta',
    cost: 'Pacientes que no vuelven'
  }, {
    situation: 'Sin menús rotativos',
    cost: "Domingos respondiendo '¿qué como?'"
  }, {
    situation: 'Sin gestión de WhatsApp',
    cost: 'Mensajes sin responder, turnos perdidos'
  }, {
    situation: 'Sin tarifario actualizado',
    cost: 'Ingresos reales que bajan con la inflación'
  }];
  return <section className="py-12 px-4 max-w-4xl mx-auto" data-id="element-73">
      <FadeIn data-id="element-74">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-75">
          <span className="text-4xl" data-id="element-76">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-gray-900 border border-gray-800 rounded-2xl overflow-hidden" data-id="element-77">
          <div className="grid grid-cols-2 bg-gray-800/80 border-b border-gray-700 p-4 font-bold" data-id="element-78">
            <div className="text-gray-400" data-id="element-79">Situación actual</div>
            <div className="text-red-400" data-id="element-80">Costo real</div>
          </div>

          <div className="divide-y divide-gray-800/50" data-id="element-81">
            {costs.map((item, index) => <div key={index} className="grid grid-cols-2 p-4 items-center hover:bg-gray-800/30 transition-colors" data-id="element-82">
                <div className="text-gray-300 pr-4" data-id="element-83">{item.situation}</div>
                <div className="font-bold text-red-400 flex items-center gap-2" data-id="element-84">
                  <AlertOctagon size={16} className="shrink-0" data-id="element-85" />
                  <span data-id="element-86">{item.cost}</span>
                </div>
              </div>)}
          </div>
        </div>
      </FadeIn>
    </section>;
}